export const generateId = () => 
  Math.random().toString(36).substr(2, 9);

export const generateToken = () => 
  Math.random().toString(36).substr(2, 16);